class ArticleTabs extends HTMLElement {
  static get observedAttributes() {
    return ['data-active'];
  }

  attributeChangedCallback(name, oldValue, newValue) { 
    if (name == 'data-active') { 
      this.toggleTab(newValue)
      this.filterSliderContent(newValue)
    }
  }

  constructor() { 
    super();
    this.stringifiedTags = this.dataset.tags
    this.triggerWrapper = this.querySelector('.js-trigger-wrapper')
    this.triggers = this.triggerWrapper?.querySelectorAll('.js-tab-trigger')
    this.sliderElement = this.querySelector('.carousel')
    this.slider = new Flickity(this.sliderElement, {
      wrapAround: true
    });
    this.activeTabElement = this.triggerWrapper.querySelector('.js-tab-trigger.active') 
    this.activeTab = this.activeTabElement.dataset.tag
    this.triggerWrapper.addEventListener('click', this.handleTriggerClick.bind(this)) 
    this.removedSlides = [];
  }

  toggleTab(tab) {
    this.activeTabElement.classList.remove('active')
    this.activeTabElement = this.querySelector(`.js-tab-trigger[data-tag="${tab}"]`)
    this.activeTabElement.classList.add('active')
  }

  filterSliderContent(tag) {
    const flkty = Flickity.data(this.sliderElement);
    let allSlides = Array.from(this.sliderElement.querySelectorAll('.carousel__slide')).concat(this.removedSlides); 
    if (tag === 'All') {
      this.removedSlides.forEach(slide => {  
          flkty.append(slide); 
      });

      flkty.reloadCells();
      flkty.select(0);  
      this.removedSlides = [];  
      return;  
    }

    allSlides.forEach(slide => {
      if (!slide.dataset.tags.includes(tag)) { 
        if (this.sliderElement.contains(slide)) { 
          this.removedSlides.push(slide); 
          flkty.remove(slide); 
          
        }
      } else { 
        if (this.removedSlides.includes(slide)) { 
          flkty.append(slide);
          this.removedSlides.filter(remove_slide => remove_slide == slide)
        }
      }
    });
 
    flkty.reloadCells();
    flkty.select(0);  
  }

  handleTriggerClick(evt) {

    if (evt.target.closest('.js-tab-trigger')) { 
      let trigger = evt.target.closest('.js-tab-trigger') 
      if (this.dataset.active !== trigger.dataset.tag) {
        this.setAttribute('data-active', trigger.dataset.tag)
      }
    }
  }

}

!customElements.get('article-tabs') && customElements.define('article-tabs', ArticleTabs)